/*
 * Copyright (c) 2017-present, flop! contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 * https://framagit.org/flopedt/flopedt
 */

import { createPinia } from 'pinia'
import { Quasar } from 'quasar'
import { createApp } from 'vue'

import { i18n } from '@/i18n/index.ts'
import { i18nExtras } from '@/i18n/plugin.ts'
import { initSettings } from '@/i18n/settings.ts'
import router from '@/router/index.ts'

import App from './App.vue'

import './date-compat.ts'
import './everybody-do-the-flop.ts'

import './styles/main.css'

initSettings()

createApp(App)
  .use(router)
  .use(createPinia())
  .use(i18n)
  .use(i18nExtras)
  .use(Quasar, {
    plugins: {},
  })
  .mount('#app')
